import ISO6391 from 'iso-639-1';

// The listing language selector labels each locale with its two-letter ISO 639-1 code.
// The server sends the locale's native language name (from the l10n files), which
// iso-639-1 can only resolve when it is an exact English or native name. A data slip
// such as "España" or "English (Ghana)" must not blank the option, so fall back to the
// language subtag of the locale code ("es_ES" -> "es") and, failing that, to the name.
export function getLanguageCode(lang) {
  const name = typeof lang?.name === 'string' ? lang.name : '';
  const code = typeof lang?.code === 'string' ? lang.code : '';

  return ISO6391.getCode(name) || code.split(/[_-]/)[0].toLowerCase() || name;
}
